import {
  Navigate,
  Outlet,
  useNavigate,
} from 'react-router-dom';
import { Suspense, lazy, useEffect } from 'react';
import { useMonitoringData } from '@/stores/monitoringStore';


const RequireAuth = () => {
  const navigate = useNavigate();
  const { setNavigationCallback } = useMonitoringData();

  // Set navigation callback for global auto-refresh and danger alerts
  useEffect(() => {
    setNavigationCallback(navigate);
  }, [setNavigationCallback, navigate]);

  return localStorage.getItem('token') ? <Outlet /> : <Navigate to="/login" replace />;
};

const Lazy = (factory: () => Promise<{ default: React.ComponentType }>) => {
  const C = lazy(factory);
  return (
    <Suspense fallback={<div>Loading…</div>}>
      <C />
    </Suspense>
  );
};

export {
  RequireAuth,
  Lazy,
};